import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface PlanChangeConfirmData {
  title: string;
  // Bullet points describing what happens on confirm.
  points: string[];
  confirmLabel?: string;
  cancelLabel?: string;
}

/**
 * Confirmation for an in-place (immediate) plan change — e.g. Pro → Team — where
 * the backend charges the card on file as soon as the request is made. Returns
 * true via the dialog result when the user confirms.
 */
@Component({
  selector: 'app-plan-change-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title class="tw-text-xl tw-font-semibold tw-text-dark-light-dynamic">
      {{ data.title }}
    </h2>
    <div mat-dialog-content>
      <ul class="tw-list-none tw-pl-0 tw-my-2 tw-flex tw-flex-col tw-gap-2">
        <li
          *ngFor="let point of data.points"
          class="tw-flex tw-items-start tw-gap-2 tw-text-sm tw-text-gray-700 dark:tw-text-gray-300">
          <mat-icon class="tw-text-base tw-w-5 tw-h-5 tw-text-teal-500 tw-shrink-0">check</mat-icon>
          <span>{{ point }}</span>
        </li>
      </ul>
    </div>
    <div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
      <button mat-stroked-button [mat-dialog-close]="false">
        {{ data.cancelLabel || 'Cancel' }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
        {{ data.confirmLabel || 'Confirm' }}
      </button>
    </div>
  `,
})
export class PlanChangeConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PlanChangeConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PlanChangeConfirmData
  ) {}
}
